import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscover = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 32,
	viewBox: "0 0 50 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6179:90714)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M1 3C1 1.89543 1.89543 1 3 1H47C48.1046 1 49 1.89543 49 3V29C49 30.1046 48.1046 31 47 31H3C1.89543 31 1 30.1046 1 29V3Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.3138 0.442963H0.686432V31.3707H49.3138V0.442963Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1269 17.6768C49.1269 17.6768 35.8056 27.0856 11.4919 31.2776H49.1269V17.6768Z",
					fill: "#EE7623"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.3137 0.349815H0.5V31.6502H49.5V0.349815H49.3137ZM49.1274 0.629282V31.1844H0.872618C0.872618 30.8118 0.872618 0.90875 0.872618 0.629282C1.24524 0.629282 48.7548 0.629282 49.1274 0.629282Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.78505 9.85172H2.82877V16.9316H4.87819C5.99606 16.9316 6.74131 16.6521 7.3934 16.0932C8.2318 15.4411 8.69759 14.4164 8.69759 13.3916C8.60443 11.3422 7.02079 9.85172 4.78505 9.85172ZM6.46184 15.1616C5.99606 15.5342 5.43712 15.7205 4.59872 15.7205H4.2261V11.0627H4.59872C5.53028 11.0627 5.99606 11.2491 6.46184 11.6217C6.92762 12.0875 7.20709 12.7395 7.20709 13.3916C7.20709 14.1369 6.92762 14.789 6.46184 15.1616Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.6542 9.85172H9.25684V16.9316H10.6542V9.85172Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.0073 12.6464C13.1689 12.3669 12.8895 12.1806 12.8895 11.7148C12.8895 11.2491 13.3552 10.9696 13.9142 10.9696C14.2868 10.9696 14.6594 11.1559 15.032 11.5285L15.7773 10.597C15.2183 10.038 14.4731 9.85172 13.7279 9.85172C12.5168 9.85172 11.4921 10.6901 11.4921 11.9011C11.4921 12.8327 11.9579 13.3916 13.2621 13.8574C13.821 14.0437 14.1005 14.1369 14.1936 14.23C14.4731 14.4164 14.5663 14.6958 14.5663 14.9753C14.5663 15.5342 14.1005 16 13.4484 16C12.7963 16 12.2374 15.6274 11.9579 15.0684L11.0263 15.9068C11.6784 16.8384 12.4237 17.211 13.4484 17.211C14.8457 17.211 15.8704 16.2795 15.8704 14.8821C16.0568 13.6711 15.591 13.2053 14.0073 12.6464Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.5233 13.3916C16.5233 15.4411 18.2001 17.1179 20.2495 17.1179C20.8085 17.1179 21.3674 17.0247 22.0195 16.7453V15.0685C21.4606 15.6274 20.9948 15.8137 20.3427 15.8137C18.9453 15.8137 17.9206 14.789 17.9206 13.3916C17.9206 11.9943 18.9453 10.9696 20.2495 10.9696C20.9016 10.9696 21.3674 11.2491 22.0195 11.808V10.2243C21.3674 9.94488 20.9016 9.75857 20.3427 9.75857C18.2001 9.75857 16.5233 11.3422 16.5233 13.3916Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.9185 14.6027L31.0553 9.85172H29.5648L32.5458 17.1179H33.2911L36.3652 9.85172H34.8747L32.9185 14.6027Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.924 16.9316H40.8365V15.8137H38.3213V13.8574H40.7434V12.6464H38.3213V11.0627H40.8365V9.85172H36.924V16.9316Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.3326 11.9943C46.3326 10.6901 45.4011 9.94486 43.8174 9.94486H41.768V16.9316H43.1653V14.1369H43.3516L45.3079 17.0247H46.9847L44.749 14.0437C45.7737 13.7643 46.3326 13.019 46.3326 11.9943ZM43.538 13.1122H43.1653V10.9696H43.6311C44.4695 10.9696 44.9353 11.3422 44.9353 11.9943C44.9353 12.7395 44.4695 13.1122 43.538 13.1122Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.9373 13.3917C29.9373 15.4411 28.2605 17.1179 26.211 17.1179C24.1616 17.1179 22.4848 15.4411 22.4848 13.3917C22.4848 11.3422 24.1616 9.66542 26.211 9.66542C28.2605 9.66542 29.9373 11.3422 29.9373 13.3917Z",
					fill: "#EE7623"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.0777 10.038C47.0777 9.94487 46.9846 9.85172 46.7983 9.85172H46.612V10.4107H46.7983V10.1312L46.9846 10.4107H47.1709L46.9846 10.1312C47.0777 10.1312 47.0777 10.1312 47.0777 10.038ZM46.7983 10.1312V9.94487C46.8914 9.94487 46.8914 9.94487 46.8914 10.038C46.8914 10.038 46.8914 10.1312 46.7983 10.1312Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.8917 9.57227C46.6123 9.57227 46.3328 9.85174 46.3328 10.1312C46.3328 10.4107 46.6123 10.6901 46.8917 10.6901C47.1712 10.6901 47.4507 10.4107 47.4507 10.1312C47.4507 9.85174 47.1712 9.57227 46.8917 9.57227ZM46.8917 10.597C46.6123 10.597 46.426 10.4107 46.426 10.1312C46.426 9.85174 46.6123 9.66543 46.8917 9.66543C47.1712 9.66543 47.3575 9.85174 47.3575 10.1312C47.2644 10.4107 47.078 10.597 46.8917 10.597Z",
					fill: "#231F20"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 2H47V0H3V2ZM48 3V29H50V3H48ZM47 30H3V32H47V30ZM2 29V3H0V29H2ZM3 30C2.44772 30 2 29.5523 2 29H0C0 30.6569 1.34315 32 3 32V30ZM48 29C48 29.5523 47.5523 30 47 30V32C48.6569 32 50 30.6569 50 29H48ZM47 2C47.5523 2 48 2.44772 48 3H50C50 1.34315 48.6569 0 47 0V2ZM3 0C1.34315 0 0 1.34315 0 3H2C2 2.44772 2.44772 2 3 2V0Z",
			fill: "#D9DADC"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6179:90714",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1 3C1 1.89543 1.89543 1 3 1H47C48.1046 1 49 1.89543 49 3V29C49 30.1046 48.1046 31 47 31H3C1.89543 31 1 30.1046 1 29V3Z",
				fill: "white"
			})
		}) })
	]
});
export default SvgDiscover;
